export default {
  metaTitle: '申请大促活动',
  pageTitle: '开始提交调价',
  applied: '当前报名类型和规格为',
  main1: '大促活动',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  placeholder3: 'Listing标题',
  placeholder4: '店内分类',
  placeholder5: '选择上架时间',
  filter: '过滤',
  buttonName1: '平台类目',
  buttonName2: '平台类目',
  columns1: '全选',
  columns2: 'Listing ID',
  columns3: '标题',
  columns4: '最低商品价',
  columns5: '最高商品价',
  columns6: '可售sku数'
}
